import React, { useContext, useState } from 'react';
import { InputField, RadioGroupField } from '@trp-beacon-ui-kit/react-controls';
import styles from './style.css';
import { FlowContext } from '../../core/flow-engine';
import {
  formatSsnForDisplay,
  handleInputFormat
} from '../../flows/shared/utils';
import { invalidCitizenshipValue, mapCitizenshipToSsnLabel } from './util';
import {
  restrictedFirstNameValidation,
  restrictedMiddleNameValidation,
  restrictedLastNameValidation
} from '../../flows/shared/validations';
import { MFBeaconButton } from '../Beacon/BeaconComponents';
import { withDefault } from '../../core/util';
import { generateJointOrCoTrustTestID } from '../../generateAutomationTestIDs';

const JointOwnerPIDetails = ({
  sectionKey,
  getDefault,
  makeName,
  removeSection
}) => {
  const {
    formProps: {
      jointOwnerFirstName,
      jointOwnerMiddleName,
      jointOwnerLastName,
      jointOwnerDob,
      jointOwnerCitizenship,
      jointOwnerSsn
    }
  } = useContext(FlowContext);

  const [ssnLabel, setSsnLabel] = useState(
    mapCitizenshipToSsnLabel(getDefault(jointOwnerCitizenship?.name))
  );
  const [dobValue, setDobValue] = useState('');
  const [ssnValue, setSSNValue] = useState('');

  const handleCitizenshipBtnClick = ({ target: { value } }) =>
    setSsnLabel(mapCitizenshipToSsnLabel(value));

  return (
    <div key={sectionKey} className="section" data-name="jointOwnerSection">
      <div className="name-fields">
        <div className="first-name">
          <InputField
            type="text"
            title="First Name"
            {...jointOwnerFirstName}
            name={makeName(jointOwnerFirstName?.name)}
            defaultValue={getDefault(jointOwnerFirstName?.name)}
            validation={restrictedFirstNameValidation}
            className="blocked_data"
            data-name={generateJointOrCoTrustTestID(
              'JointOwnerPI',
              'FirstName',
              sectionKey
            )}
          />
        </div>

        <div className="middle-name">
          <InputField
            type="text"
            title="Middle Name"
            {...jointOwnerMiddleName}
            name={makeName(jointOwnerMiddleName?.name)}
            defaultValue={getDefault(jointOwnerMiddleName?.name)}
            validation={restrictedMiddleNameValidation}
            className="blocked_data"
            data-name={generateJointOrCoTrustTestID(
              'JointOwnerPI',
              'MiddleName',
              sectionKey
            )}
          />
        </div>
        <div className="last-name">
          <InputField
            type="text"
            title="Last Name"
            {...jointOwnerLastName}
            name={makeName(jointOwnerLastName?.name)}
            defaultValue={getDefault(jointOwnerLastName?.name)}
            validation={restrictedLastNameValidation}
            className="blocked_data"
            data-name={generateJointOrCoTrustTestID(
              'JointOwnerPI',
              'LastName',
              sectionKey
            )}
          />
        </div>
      </div>
      <div className="personal-info-fields">
        <div className="dob-input">
          <InputField
            style={{ paddingRight: '8px' }}
            type="text"
            title="Date of Birth"
            aria-describedby="hint"
            {...jointOwnerDob}
            name={makeName(jointOwnerDob?.name)}
            value={withDefault(dobValue, getDefault(jointOwnerDob?.name))}
            maxLength="10"
            onChange={evt => handleInputFormat(evt, 'DATE', setDobValue)}
            placeholder="mm/dd/yyyy"
            className="blocked_data"
            data-name={generateJointOrCoTrustTestID(
              'JointOwnerPI',
              'BirthDate',
              sectionKey
            )}
          />
          <dd id="hint" style={{ display: 'none' }}>
            This is a required field. Please enter a two digit month, a two
            digit day and a four digit year for the Date of Birth value.
          </dd>
        </div>
        <div className="ssn-input">
          <InputField
            title={ssnLabel}
            placeholder="000-00-0000"
            maxLength="11"
            onChange={evt => handleInputFormat(evt, 'SSN', setSSNValue)}
            {...jointOwnerSsn}
            name={makeName(jointOwnerSsn?.name)}
            value={withDefault(
              ssnValue,
              formatSsnForDisplay(getDefault(jointOwnerSsn?.name))
            )}
            className="blocked_data"
            data-name={generateJointOrCoTrustTestID(
              'JointOwnerPI',
              'TaxID',
              sectionKey
            )}
          />
        </div>
        <div className="citizenship-input joint-owner">
          <RadioGroupField
            title="Citizenship"
            onChange={handleCitizenshipBtnClick}
            {...jointOwnerCitizenship}
            name={makeName(jointOwnerCitizenship?.name)}
            options={[
              {
                title: 'U.S. Citizen',
                value: 'US_CITIZEN',
                defaultChecked:
                  getDefault(jointOwnerCitizenship?.name) === 'US_CITIZEN' ||
                  invalidCitizenshipValue(
                    getDefault(jointOwnerCitizenship?.name)
                  )
              },
              {
                title: 'U.S. Resident Alien',
                value: 'RESIDENT_ALIEN',
                defaultChecked:
                  getDefault(jointOwnerCitizenship?.name) === 'RESIDENT_ALIEN'
              }
            ]}
          />
        </div>
      </div>
      {sectionKey > 0 && (
        <div className="remove-section-button">
          <MFBeaconButton
            type="button"
            id="removeJointOwner"
            data-name={generateJointOrCoTrustTestID(
              'JointOwnerPI',
              'RemoveJointOwnerButton',
              sectionKey
            )}
            onClick={removeSection}
            variant="tertiary"
            label="X remove"
          />
        </div>
      )}
      <hr />
      <style jsx>{styles}</style>
    </div>
  );
};

export default JointOwnerPIDetails;
